/** The Daily Drop's numbers (04 §11). Everything about a day's mission comes from its date string. */

import type { ModifierId } from '../../sim/types';

export const DAILY = {
  /** Generator the date string is forked from: change either and every day's mission changes. */
  seed: 0x19870d0d,
  stream: 0x0da1,
  /** Chance the archetype flies in its native biome; otherwise one of the other two (03 §2.1). */
  nativeChance: 0.7,
  /** Threat 4-6: a fair fight for a standard-issue ranger with three fixed pods. */
  minThreat: 4,
  threatSpread: 3,
  /** Chance of the one modifier a daily may carry. */
  modifierChance: 0.6,
  /** Pods dropped, each packed as the C64's fixed pod. */
  pods: 3,
  /** Entries kept on the local table, newest first. */
  keep: 60,
  rangerId: 'daily',
  callsign: 'DAILY',
} as const;

/** Never rolled for a daily: the loadout is fixed, so nothing may take a pod away from some days and not others. */
export const DAILY_EXCLUDED: readonly ModifierId[] = ['two-pod-limit'];

/** Days in each month of a common year; February gains one in a leap year. */
export const MONTH_DAYS: readonly number[] = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
